import React from "react";

const Contact = () => (
  <section id="contact" className="py-20 bg-[#f0f4ff] text-center px-6">
    <h2 className="text-3xl font-bold mb-6">Request Early Access</h2>
    <form
      action="https://formspree.io/f/xyzjveel"
      method="POST"
      className="max-w-md mx-auto"
    >
      <input
        type="email"
        name="email"
        placeholder="Your email address"
        required
        className="w-full p-3 border rounded-xl mb-4"
      />
      <button
        type="submit"
        className="w-full bg-indigo-600 text-white font-semibold py-3 rounded-xl hover:bg-indigo-700"
      >
        Notify Me
      </button>
    </form>
  </section>
);

export default Contact;
